import {
  HistoricoSolicitacaoListParams,
  HistoricoSolicitacaoListResponse,
} from "@/models/auction-historico.model";
import { axiosLeilaoConsignadoTrabalhadorInstance } from "./axiosInstance";

const USE_MOCK_AUCTION_PROPOSALS =
  import.meta.env.VITE_USE_AUCTION_MOCKS === "true";

/**
 * Lista, paginado, o histórico durável das solicitações de leilão (tabela
 * `leilao_solicitacao_historico`) — o registro que sobrevive ao expurgo do
 * Redis (TTL 10min), incluindo leilões perdidos e os que não disputamos, que
 * nunca viram `PropostaLeilao`.
 *
 * Endpoint: GET /api-consignado-trabalhador/v1/proposta-leilao/historico
 *
 * Query params:
 *  - pagina, tamanho_pagina
 *  - status (CSV)
 *  - codigo_lote
 *  - search_term (CPF completo ou número da solicitação)
 *  - motivo_sem_lance, codigo_erro_lance
 *  - data_inicial, data_final (YYYY-MM-DD)
 */
export async function getAuctionHistoricoSolicitacoes(
  params: HistoricoSolicitacaoListParams,
): Promise<HistoricoSolicitacaoListResponse> {
  if (USE_MOCK_AUCTION_PROPOSALS) {
    const { getMockAuctionHistoricoSolicitacoes } = await import(
      "@/mocks/auctionHistorico.mock"
    );
    return getMockAuctionHistoricoSolicitacoes(params);
  }

  const queryParams = new URLSearchParams();
  queryParams.set("pagina", String(params.page));
  queryParams.set("tamanho_pagina", String(params.pageSize));

  if (params.statuses?.length) {
    queryParams.set("status", params.statuses.join(","));
  }

  const codigoLote = params.codigoLote?.trim();
  if (codigoLote) {
    queryParams.set("codigo_lote", codigoLote);
  }

  const searchTerm = params.searchTerm?.trim();
  if (searchTerm) {
    queryParams.set("search_term", searchTerm);
  }

  if (params.motivoSemLance) {
    queryParams.set("motivo_sem_lance", params.motivoSemLance);
  }

  const codigoErroLance = params.codigoErroLance?.trim();
  if (codigoErroLance) {
    queryParams.set("codigo_erro_lance", codigoErroLance);
  }

  if (params.dataInicial) {
    queryParams.set("data_inicial", params.dataInicial);
  }

  if (params.dataFinal) {
    queryParams.set("data_final", params.dataFinal);
  }

  const { data } =
    await axiosLeilaoConsignadoTrabalhadorInstance.get<HistoricoSolicitacaoListResponse>(
      "/api-consignado-trabalhador/v1/proposta-leilao/historico",
      { params: queryParams },
    );

  return data;
}
